import React from "react";
import "./TextComponent.css";
import Paragraph from "./Paragraph";

const TextComponent = ({ height, text }) => {
  return (
    <>
      <div className="tcContainer" style={{ height: { height } }}>
        <Paragraph text={text} />
      </div>
    </>
  );
};

export default TextComponent;
